module.exports = __webpack_public_path__ + "img/down_arrow.0d87919f.svg";